import { Component, FormEvent } from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from "react-redux";
import { IVrlTransactionGroup } from '@nkr/models/index';
import { VrlCategory } from '@nkr/enums/index';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IVrlDetailReportResponse, IVrlDetailReports } from '@nkr/store/index';
import { HeaderWrapper, NavItemWrapper, NavWrapper } from './styles';
import { Button, ButtonToolbar, FormControl, Nav, ToggleButton, ToggleButtonGroup, Well } from 'react-bootstrap';
import { GridApi, ColumnApi, GridReadyEvent, CsvExportParams, ProcessCellForExportParams } from 'ag-grid-community';
import { downloadFile } from '@nkr/services/download-file';
import VrlTransDetailGridSerology from './vrl-trans-detail-grid-serology';
import VrlTransDetailGridAntibody from './vrl-trans-detail-grid-antibody';

interface IOwnProps {
}

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getVrlReport: (filterBy: number, startDate: string, endDate: string, vrltransaction: IVrlTransactionGroup) => Promise<IVrlDetailReportResponse>,
    getVrlExport: (filterBy: number, startDate: string, endDate: string, reportId: number, vrltransaction: IVrlTransactionGroup) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    filterBy: number,
    startDate: string,
    endDate: string,
    centerId: number,
    activeTab: VrlCategory,
    report: IVrlDetailReports,
    radioFilter: number,
    vrlTransactionGroup: IVrlTransactionGroup,
}

class VrlReportList extends Component<TProps, IState> {
    readonly state: IState = {
        filterBy: 0,
        startDate: __ENVIRONMENT__ == 'dev' ? '2022-09-01' : moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
        centerId: 0,
        activeTab: 0,
        report: {
            serologyResults: [],
            antibodyResults: []
        },
        radioFilter: 1,
        vrlTransactionGroup: {
            All: false,
            Completed: true
        },
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;

        e.api.sizeColumnsToFit();
    }

    componentDidMount = () => {
        //this.getData(this.state.startDate, this.state.endDate, this.state.vrlTransactionGroup);
        this.getData();
    }

    //getData = (startDate: string, endDate: string, vrltransaction: IVrlTransactionGroup) => {
    getData = () => {
        let { filterBy, startDate, endDate, vrlTransactionGroup } = this.state;

        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getVrlReport(filterBy, startDate, endDate, vrlTransactionGroup)
                .then((response: IVrlDetailReportResponse) => {
                    this.setState({
                        startDate: startDate,
                        endDate: endDate,
                        report: response.data.results
                    });

                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }

    dateRangeSearch = () => {
        this.getData();
    }

    onGridSizeChanged = () => {
        // get the current grids width
        let gridWidth = document.getElementById('grid-wrapper').offsetWidth;

        // keep track of which columns to hide/show
        let columnsToShow = [];
        let columnsToHide = [];

        // iterate over all columns (visible or not) and work out
        // now many columns can fit (based on their minWidth)
        let totalColsWidth = 0;
        let allColumns = this.gridColumnApi.getAllColumns();

        for (let i = 0; i < allColumns.length; i++) {
            let column = allColumns[i];
            totalColsWidth += column.getMinWidth();

            if (totalColsWidth > gridWidth) {
                columnsToHide.push(column.getColId);
            } else {
                columnsToShow.push(column.getColId);
            }
        }

        // show/hide columns based on current grid width
        this.gridColumnApi.setColumnsVisible(columnsToShow, true);
        this.gridColumnApi.setColumnsVisible(columnsToHide, false);

        // fill out any available space to ensure there are no gaps
        this.gridApi.sizeColumnsToFit();
    }

    handleDateChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let id = e.currentTarget.id;
        let value = e.currentTarget.value;

        if (id == 'startDate') {
            this.setState({
                startDate: value
            });
        }

        if (id == 'endDate') {
            this.setState({
                endDate: value
            });
        }
    }

    handleExportVrl = (reportId: number) => {
        let { filterBy, startDate, endDate, vrlTransactionGroup } = this.state;

        let filenName = '';

        this.props.showLoading("Exporting CSV file, one moment please...").then(() => {
            this.props.getVrlExport(filterBy, startDate, endDate, reportId, vrlTransactionGroup).then((response: any) => {
                switch (reportId) {
                    case 1: filenName = 'serology'; break;
                    case 2: filenName = 'antibodyscreening'; break;
                }

                downloadFile(response.data, `vrl-transactions-` + filenName + `.csv`, 'text/csv');

                this.props.hideLoading();
            });
        });
    }

    handleFilterByChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            filterBy: parseInt(e.currentTarget.value)
        });
    }

    handleRadioFilterChange = (radioType: number) => {
        this.setState({
            radioFilter: radioType,
            vrlTransactionGroup: {
                All: radioType == 0 ? true : false,
                Completed: radioType == 1 ? true : false
            }
        }, () => {
            this.getData();
        });
    }

    handleTabChange = (selectedTab: number) => {
        this.setState({
            activeTab: selectedTab
        });
    }

    // handleExport = () => {
    //     let params: CsvExportParams = {
    //         columnGroups: true,
    //         fileName: 'vrl-transactions-detail.csv',
    //         processCellCallback: (params: ProcessCellForExportParams) => {
    //             let colDef = params.column.getColDef();

    //             if (colDef.headerName == 'Rank')
    //                 return params.node.rowIndex + 1;
    //             else if (colDef.colId == 'xpDate')
    //                 return moment(params.value).format('MM/DD/YYYY');

    //             return params.value;
    //         }
    //     };

    //     this.gridApi.exportDataAsCsv(params);
    // }

    render = () => {
        const totalSerology = this.state.report.serologyResults.length;
        const totalAntiBodyScreening = this.state.report.antibodyResults.length;
        const tabWidth = '230';

        return (
            <>
                <HeaderWrapper className='container-fluid'>
                    <div className='billing-header' style={{ marginBottom: 10 }}>
                        VRL Transactions Report
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.filterBy}
                                    onChange={this.handleFilterByChange}
                                >
                                    <option value={0}>Filter by Completed Date</option>
                                    <option value={1}>Filter by Requested Date</option>
                                </FormControl>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                                <div>
                                    <FormControl
                                        id='startDate'
                                        type='date'
                                        name='startDate'
                                        value={this.state.startDate}
                                        onChange={this.handleDateChange}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <div style={{ marginRight: 5 }}>End Date:</div>
                                <div>
                                    <FormControl
                                        id='endDate'
                                        type='date'
                                        name='endDate'
                                        value={this.state.endDate}
                                        onChange={this.handleDateChange}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <Button bsStyle={'primary'} onClick={this.dateRangeSearch}>Search</Button>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }} >
                                <div style={{ marginRight: 5 }}>Filters:</div>
                                <ButtonToolbar>
                                    <ToggleButtonGroup type="radio" name="options" defaultValue={this.state.radioFilter}>
                                        <ToggleButton className="btn-bg" onClick={() => this.handleRadioFilterChange(0)} value={0}>
                                            All
                                        </ToggleButton>
                                        <ToggleButton className="btn-bg" onClick={() => this.handleRadioFilterChange(1)} value={1}>
                                            Completed
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </ButtonToolbar>
                            </div>
                        </div>

                        <Well style={{ fontSize: 14, padding: 10, margin: 0 }}>
                            <div style={{ display: 'flex' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                                    <div style={{ marginRight: 20 }}>Serologies:&nbsp;<strong>{totalSerology}</strong></div>
                                    <Button bsStyle="success" bsSize="xsmall" onClick={() => this.handleExportVrl(1)}>Export CSV</Button>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ marginRight: 20 }}>Antibody Screenings:&nbsp;<strong>{totalAntiBodyScreening}</strong></div>
                                    <Button bsStyle="success" bsSize="xsmall" onClick={() => this.handleExportVrl(2)}>Export CSV</Button>
                                </div>
                            </div>
                        </Well>
                    </div>
                </HeaderWrapper>

                <NavWrapper verticalAlign='center' minTabWidth='85' fontSize='12px'>
                    <div style={{ paddingLeft: 15, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Nav bsStyle='tabs' className='acc-tabs' onSelect={(e: any) => this.handleTabChange(e)}>
                            <NavItemWrapper eventKey={VrlCategory.Serology} active={this.state.activeTab == VrlCategory.Serology} tabWidth={tabWidth}>
                                Serologies <b>({totalSerology})</b>
                            </NavItemWrapper>

                            <NavItemWrapper eventKey={VrlCategory.AntibodyScreening} active={this.state.activeTab == VrlCategory.AntibodyScreening} tabWidth={tabWidth}>
                                Antibody Screenings <b>({totalAntiBodyScreening})</b>
                            </NavItemWrapper>
                        </Nav>
                    </div>
                </NavWrapper>

                {this.state.activeTab == VrlCategory.Serology && (
                    <VrlTransDetailGridSerology reportList={this.state.report.serologyResults} />
                )}

                {this.state.activeTab == VrlCategory.AntibodyScreening && (
                    <VrlTransDetailGridAntibody reportList={this.state.report.antibodyResults} />
                )}
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getVrlReport: (filterBy, startDate, endDate, vrltransaction) => {
            return dispatch(ReportActionCreators.getVrlReport(filterBy, startDate, endDate, vrltransaction));
        },
        getVrlExport: (filterBy, startDate, endDate, reportId, vrltransaction) => {
            return dispatch(ReportActionCreators.getVrlExport(filterBy, startDate, endDate, reportId, vrltransaction));
        },
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(VrlReportList);